module.exports = __webpack_public_path__ + "img/loginVerify.f641009a.jpg";